import React, { FC } from 'react'
import { Header } from 'views/components'
import HotIconFill from 'views/components/atoms/Icons/Other/HotFill'
import styles from './IntegrationsContent.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { integrationsApiEvents, integrationsApiSelectors } from 'modules/api/integrations'
import IntegrationCard from '../IntegrationCard/IntegrationCard'
import { useEffectOnce } from 'react-use'
import TpnReportCard from '../TpnReport/TpnReportCard'

type TStaticIntegration = {
  Component: JSX.Element
}
const IntegrationsContent: FC = () => {
  const dispatch = useDispatch()

  useEffectOnce(() => {
    dispatch(integrationsApiEvents.integrations_request())
  })

  const integrationsList = useSelector(integrationsApiSelectors.getIntegrationsList)
  // `orderNo` is optional on the service response, so unordered integrations sort to the front
  // rather than turning the whole comparison into NaN.
  const sortedIntegrationsList = [...integrationsList].sort((a, b) => (a.orderNo ?? 0) - (b.orderNo ?? 0))
  const staticIntegrations: TStaticIntegration[] = [
    {
      Component: <TpnReportCard name="TPN" short="Send your rental payment data to TPN automatically." />,
    },
  ]

  return (
    <div className={styles.root}>
      <Header icon={<HotIconFill />} text="Integrations" />
      <div className={styles.integrations}>
        {staticIntegrations.map((item, i: number) => (
          <React.Fragment key={i}>{item.Component}</React.Fragment>
        ))}
        {sortedIntegrationsList.map((item, i: number) => (
          <IntegrationCard key={i} integration={item} />
        ))}
      </div>
    </div>
  )
}

export default IntegrationsContent
